import { FilterBy, FilterTemplate } from '../../common/Filters/FilterView/FilterTemplate'
import { AdCreativesRequestParams } from '../../../api/nm-types'
import { format } from 'date-fns'
import { DATE_FORMAT_LONGER, sentenceCase } from 'common/api/v1/helpers'
import { dateFilterPossibleValues } from '../../common/Filters/FilterView/dateFilter'
import { AdCreativeStatus } from 'common/api/v1/types'

export enum AdCreativeFilterKey {
  name = 'name',
  created = 'created',
  status = 'status',
}

export function mapAdCreativeFilterToUrlParam(filter: FilterBy): Partial<AdCreativesRequestParams> {
  if ('value' in filter) {
    switch (filter.key) {
      case AdCreativeFilterKey.name:
        return { filter: filter.value }
      case AdCreativeFilterKey.created:
        return filter.operator === 'after'
          ? { fromDate: new Date(filter.value).toISOString() }
          : { toDate: new Date(filter.value).toISOString() }
      case AdCreativeFilterKey.status:
        return { status: filter.value as AdCreativeStatus }
    }
  }
  return {}
}

export function mapUrlParamToAdCreativeFilter(
  key: keyof AdCreativesRequestParams,
  value: string,
): FilterBy | undefined {
  switch (key) {
    case 'filter':
      return {
        key: AdCreativeFilterKey.name,
        operator: 'matches',
        value,
      }
    case 'fromDate':
      return {
        key: AdCreativeFilterKey.created,
        operator: 'after',
        value: format(new Date(value), DATE_FORMAT_LONGER),
      }
    case 'toDate':
      return {
        key: AdCreativeFilterKey.created,
        operator: 'before',
        value: format(new Date(value), DATE_FORMAT_LONGER),
      }
    case 'status':
      return {
        key: AdCreativeFilterKey.status,
        operator: 'is',
        value: value as AdCreativeStatus,
        displayName: sentenceCase(value),
      }
  }
  return undefined
}

export function makeAdCreativeFilters(): FilterTemplate[] {
  const filterTemplates: FilterTemplate[] = [
    { key: AdCreativeFilterKey.name, operator: 'matches' },
    {
      key: AdCreativeFilterKey.created,
      operator: 'after',
      possibleValuesSync: (s) => dateFilterPossibleValues(s),
    },
    {
      key: AdCreativeFilterKey.created,
      operator: 'before',
      possibleValuesSync: (s) => dateFilterPossibleValues(s),
    },
    {
      key: AdCreativeFilterKey.status,
      operator: 'is',
      possibleValuesSync: () =>
        Object.values(AdCreativeStatus).map((status) => ({
          value: status,
          displayName: sentenceCase(status),
        })),
    },
  ]
  return filterTemplates.sort((a, b) => a.key.localeCompare(b.key))
}
